jQuery(document).ready(function ($) {
    $('a[href^="#contact-us"]').on('click', function () {
        let href = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(href).offset().top
        });
        return false;
    });

    $('.challenge-list').not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        focusOnSelect: true,
        swipeToSlide: true,
        touchThreshold: 20,
        prevArrow: '<button type="button" class="prev-button"></button>',
        nextArrow: '<button type="button" class="next-button"></button>',
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0
                }
            }
        ]
    });
});